var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgMenuBurgerBlkRgb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 415.75 415.75",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,311.81 H 311.81 V 0 H 0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 0 415.75)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(228.49 212.69)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-145.18c-0.818 0-1.482-0.664-1.482-1.481v-11.852c0-0.817 0.664-1.481 1.482-1.481h145.18c0.817 0 1.481 0.664 1.481 1.481v11.852c0 0.817-0.664 1.481-1.481 1.481"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(228.49 113.93)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-145.18c-0.818 0-1.482-0.664-1.482-1.481v-11.852c0-0.817 0.664-1.48 1.482-1.48h145.18c0.817 0 1.481 0.663 1.481 1.48v11.852c0 0.817-0.664 1.481-1.481 1.481"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(228.49 163.31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-145.18c-0.818 0-1.482-0.664-1.482-1.481v-11.852c0-0.817 0.664-1.481 1.482-1.481h145.18c0.817 0 1.481 0.664 1.481 1.481v11.852c0 0.817-0.664 1.481-1.481 1.481"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBurgerBlkRgb);
export default __webpack_public_path__ + "static/media/Menu_Burger_BLK_RGB.a87eae3c13f2ebc4d81e6fa07c81be28.svg";
export { ForwardRef as ReactComponent };